import styled from 'styled-components';
import { Switcher } from 'components/atoms/switcher';

export const CpSwitcher = styled(Switcher)`
  border-radius: var(--border-radius-large);

  .ant-radio-button-wrapper:first-child {
    border-top-left-radius: var(--border-radius-large);
    border-bottom-left-radius: var(--border-radius-large);
  }

  .ant-radio-button-wrapper:last-child {
    border-top-right-radius: var(--border-radius-large);
    border-bottom-right-radius: var(--border-radius-large);
  }
`;
